import { makeStyles } from '@material-ui/core/styles';

const uploadButtonStyle = makeStyles({
  uploadButton: {
    margin: '0 24px',
    maxWidth: '212px',
    padding: '0px',
    marginTop: '-10px',
  },
  uPress: {
    fontSize: '14px',
    fontWeight: 'bolder',
    fontStretch: 'normal',
    fontStyle: 'normal',
    letterSpacing: '1px',
    textAlign: 'center',
    color: '#394867',
    textTransform: 'uppercase',
    textDecoration: 'none',
  },
});

export default uploadButtonStyle;
